
<template>
  <div>
    <div style="display:flex;">
      <AdminHeader v-bind:menu_id="'1-3'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>시스템 관리 - HOT 키워드 관리</p>
          <div class="Admin_PageHeader_btn">
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
          </div>
          <div ref="table"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_hot_keyword_top10,
  update_hot_keyword
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminMenuPermissionManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
  },
  mounted () {
    get_hot_keyword_top10().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        columns: [
          {title: 'ID', field: 'hot_keyword_ID', headerSort: false},
          {title: 'HOT키워드명', field: 'hot_keyword_name', headerSort: false},
          {
            title: '카운팅(수정가능)',
            field: 'hot_keyword_count',
            headerSort: false,
            editor: 'number',
            cellEdited: function (cell) {
              let updatedData = cell.getRow().getData()
              if (updatedData.hot_keyword_status !== '') {
                update_hot_keyword(
                  updatedData.hot_keyword_ID,
                  updatedData.hot_keyword_count,
                  updatedData.hot_keyword_status
                ).then(result_data => {
                  alert('변경이 완료되었습니다.')
                })
              }
            }
          },
          {
            title: '표시여부(수정가능)',
            field: 'hot_keyword_status',
            headerSort: false,
            editor: 'list',
            editorParams: {
              values: {
                '0': '표시',
                '1': '미표시'
              }
            },
            formatter: function (cell, formatterParams) {
              const value = cell.getValue()
              return (value === '0' || value === 0) ? '표시' : '미표시'
            },
            cellEditing: function (cell) {
              cell._initialValue = cell.getValue()
            },
            cellEdited: function (cell) {
              let updatedData = cell.getRow().getData()
              if (updatedData.hot_keyword_status === '') {
                updatedData.hot_keyword_status = cell._initialValue
                cell.getRow().update(updatedData)
              } else {
                update_hot_keyword(
                  updatedData.hot_keyword_ID,
                  updatedData.hot_keyword_count,
                  updatedData.hot_keyword_status
                ).then(result_data => {
                  alert('변경이 완료되었습니다.')
                })
              }
            }
          },
          {title: '등록일자', field: 'hoy_keyword_registe', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminHotKeywordManagement.vue